import { render } from "./IconScanQR.vue?vue&type=template&id=9650c45e"
import script from "./IconScanQR.vue?vue&type=script&lang=ts"
export * from "./IconScanQR.vue?vue&type=script&lang=ts"
script.render = render

export default script